import { useRoute } from 'vue-router'

export default defineNuxtPlugin(nuxtApp => {
	const route = useRoute()

	nuxtApp.hook('page:loading:end', () => {
		if (route.hash) {
			const element = document.getElementById(route.hash.substring(1))

			if (!element) {
				console.error('element not found: ' + route.hash.substring(1))
				return
			}

			element.scrollIntoView({ block: 'start', inline: 'start', behavior: 'smooth' })
		}
	})
})
